import * as yup from "yup";

export const TABLE_HEAD = [
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Badge name",
  },
  {
    id: "category",
    numeric: false,
    disablePadding: true,
    label: "Badge category",
  },
];

export const addTicketSchema = yup.object({
  name: yup.string().required().default(""),
  price: yup.string().required().default(""),
  condition: yup.string().required().default(""),
});
